import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useAnalytics from './useAnalytics';

interface PageInfo {
  pathname: string;
  hostname: string;
  language: string;
  fullUrl: string;
}

export const usePageTracking = () => {
  const { trackEvent } = useAnalytics();
  const location = useLocation();

  const getPageInfo = (): PageInfo => {
    const hostname = window.location.hostname;
    const fullUrl = window.location.href;
    
    // Determine language based on path and hostname
    const getLang = () => {
      const path = location.pathname;
      if (path.startsWith('/ro')) return 'ro';
      if (path.startsWith('/en')) return 'en';
      if (path.startsWith('/hu')) return 'hu';
      
      if (hostname.includes('avocat')) return 'ro';
      return 'hu';
    };

    return {
      pathname: location.pathname,
      hostname,
      language: getLang(),
      fullUrl
    };
  };

  useEffect(() => {
    const pageInfo = getPageInfo();
    
    trackEvent('page_view', {
      ...pageInfo,
      referrer: document.referrer || 'direct',
      timestamp: new Date().toISOString(),
      viewport_width: window.innerWidth,
      viewport_height: window.innerHeight,
      path_segments: location.pathname.split('/').filter(Boolean)
    });
  }, [location, trackEvent]);

  return getPageInfo;
};